/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@shared/apis/fetch-clients/radar-fetch-client";
import type { FindOneContactQueryResponse, FindOneContactPathParams, FindOneContactQueryParams, FindOneContactHeaderParams, FindOneContact404 } from "../../models/contactsController/FindOneContact";
import type { Client, RequestConfig, ResponseErrorConfig } from "@shared/apis/fetch-clients/radar-fetch-client";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const findOneContactQueryKey = (id: FindOneContactPathParams["id"], params?: FindOneContactQueryParams) => [{ url: '/contacts/:id', params: {id:id} }, ...(params ? [params] : [])] as const

export type FindOneContactQueryKey = ReturnType<typeof findOneContactQueryKey>

/**
 * @summary Retrieve a contact, with its persisted events and last research execution embedded
 * {@link /contacts/:id}
 */
export async function findOneContact(id: FindOneContactPathParams["id"], params?: FindOneContactQueryParams, headers?: FindOneContactHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<FindOneContactQueryResponse, ResponseErrorConfig<FindOneContact404>, unknown>({ method : "GET", url : `/contacts/${id}`, params, ... requestConfig, headers : { ...headers, ...requestConfig.headers } })
  return res.data
}

export function findOneContactQueryOptions(id: FindOneContactPathParams["id"], params?: FindOneContactQueryParams, headers?: FindOneContactHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = findOneContactQueryKey(id, params)
        return queryOptions<FindOneContactQueryResponse, ResponseErrorConfig<FindOneContact404>, FindOneContactQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return findOneContact(id, params, headers, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Retrieve a contact, with its persisted events and last research execution embedded
 * {@link /contacts/:id}
 */
export function useFindOneContact<TData = FindOneContactQueryResponse, TQueryData = FindOneContactQueryResponse, TQueryKey extends QueryKey = FindOneContactQueryKey>(id: FindOneContactPathParams["id"], params?: FindOneContactQueryParams, headers?: FindOneContactHeaderParams, options: 
{
  query?: Partial<QueryObserverOptions<FindOneContactQueryResponse, ResponseErrorConfig<FindOneContact404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? findOneContactQueryKey(id, params)
         

         const query = useQuery({
          ...findOneContactQueryOptions(id, params, headers, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<FindOneContact404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}